import { render, staticRenderFns } from "./DetalleVenta.vue?vue&type=template&id=01a7d0c5&"
import script from "./DetalleVenta.vue?vue&type=script&lang=ts&"
export * from "./DetalleVenta.vue?vue&type=script&lang=ts&"
import style0 from "./DetalleVenta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('01a7d0c5', component.options)
    } else {
      api.reload('01a7d0c5', component.options)
    }
    module.hot.accept("./DetalleVenta.vue?vue&type=template&id=01a7d0c5&", function () {
      api.rerender('01a7d0c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Add/modal-altas/DetalleVenta.vue"
export default component.exports